var _desc, _mask, _g, _mask2, _g2, _mask3, _g3, _mask4, _g4, _path, _path2, _mask5, _g5, _path3, _path4, _mask6, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 12,
    viewBox: "0 0 65 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "LeadfernoTitle"
  }, "Leadferno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "LeadfernoTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Leadferno logo graphic")), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 0,
    width: 10,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7984 0.0734253C27.2596 1.26406 28.0376 2.07916 27.9604 3.64696C27.7657 3.04198 27.3211 2.62305 26.9638 2.48298C27.3337 4.81745 25.1803 5.4148 24.8007 7.54323C24.4689 9.4045 25.3415 11.0573 27.9123 11.7C27.2768 11.0976 27.0774 10.3446 27.2104 9.57139C27.4989 7.89146 29.2185 7.31719 29.5678 5.73606C29.5706 5.72306 29.5729 5.71023 29.5755 5.69723C30.4932 6.54515 30.9833 8.371 30.0943 9.69196C30.546 9.57171 30.9168 9.35136 31.2165 9.06682C31.3326 9.75599 31.3501 10.8317 30.4784 11.7C34.0788 10.8867 33.7799 7.28729 33.0968 6.39874C33.03 6.89404 32.6989 7.56208 31.9509 7.95338C32.2987 7.0827 32.3275 6.07179 32.133 5.31844C31.2706 1.98101 28.2729 2.04114 27.7984 0.0734253Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7984 0.0734253C27.2596 1.26406 28.0376 2.07916 27.9604 3.64696C27.7657 3.04198 27.3211 2.62305 26.9638 2.48298C27.3337 4.81745 25.1803 5.4148 24.8007 7.54323C24.4689 9.4045 25.3415 11.0573 27.9123 11.7C27.2768 11.0976 27.0774 10.3446 27.2104 9.57139C27.4989 7.89146 29.2185 7.31719 29.5678 5.73606C29.5706 5.72306 29.5729 5.71023 29.5755 5.69723C30.4932 6.54515 30.9833 8.371 30.0943 9.69196C30.546 9.57171 30.9168 9.35136 31.2165 9.06682C31.3326 9.75599 31.3501 10.8317 30.4784 11.7C34.0788 10.8867 33.7799 7.28729 33.0968 6.39874C33.03 6.89404 32.6989 7.56208 31.9509 7.95338C32.2987 7.0827 32.3275 6.07179 32.133 5.31844C31.2706 1.98101 28.2729 2.04114 27.7984 0.0734253Z",
    fill: "#A8A8A8"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 3,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.70334H2.91817V11.5121H0V2.70334Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.87954V2.70334H1.91354V9.58587C1.91354 9.77388 2.00918 9.86782 2.20063 9.86782H2.9182V11.5121H1.66241C0.526285 11.5121 0 10.9953 0 9.87954Z",
    fill: "#A8A8A8"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 7,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33691 5.16989H9.55575V11.7H3.33691V5.16989Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16658 7.8476H7.72592C7.58237 7.13117 7.13996 6.74357 6.44625 6.74357C5.75255 6.74357 5.31013 7.13117 5.16658 7.8476ZM9.55575 8.90475H5.14271C5.27432 9.70339 5.77658 10.1262 6.57786 10.1262C7.13996 10.1262 7.54657 9.90297 7.71398 9.49193H9.48397C9.26865 10.8191 8.07269 11.7 6.50609 11.7C4.60449 11.7 3.33691 10.3962 3.33691 8.43494C3.33691 6.47351 4.58062 5.16989 6.44625 5.16989C8.31189 5.16989 9.55575 6.47351 9.55575 8.43494V8.90475Z",
    fill: "#A8A8A8"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 5,
    width: 6,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1538 5.16992H15.8346V11.7H10.1538V5.16992Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.921 8.88118V8.85774C12.5696 8.88118 11.9596 9.13953 11.9596 9.6681C11.9596 10.0323 12.2348 10.2318 12.737 10.2318C13.5023 10.2318 13.921 9.75031 13.921 8.88118ZM15.8346 7.70666V11.5122H14.0406V10.7016H13.921C13.5502 11.3476 12.9165 11.7 12.0194 11.7C10.8475 11.7 10.1538 11.101 10.1538 10.0088C10.1538 8.61111 11.3019 7.93 13.921 7.89468V7.58929C13.921 7.04899 13.622 6.75533 13.0599 6.75533C12.5577 6.75533 12.2107 6.99023 12.1869 7.47176H10.2733C10.4648 5.94496 11.589 5.16992 13.1914 5.16992C14.9256 5.16992 15.8346 6.07406 15.8346 7.70666Z",
    fill: "#A8A8A8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1445 8.43489C21.1445 7.5306 20.6422 6.93154 19.8767 6.93154C19.1234 6.93154 18.6211 7.5306 18.6211 8.43489C18.6211 9.33918 19.1234 9.93824 19.8767 9.93824C20.6422 9.93824 21.1445 9.33918 21.1445 8.43489ZM23.058 2.70328V11.5121H21.1445V10.8308H21.0608C20.7138 11.3594 20.14 11.6999 19.3385 11.6999C17.7839 11.6999 16.6718 10.3963 16.6718 8.43489C16.6477 6.47345 17.7719 5.16984 19.3385 5.16984C20.1159 5.16984 20.678 5.48695 21.025 5.99193H21.1445V2.70328H23.058Z",
    fill: "#A8A8A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9805 4.62958V5.35773H39.3559V7.00206H37.9805V11.5121H36.067V7.00206H34.9907V5.35773H36.067V4.33591C36.067 3.22016 36.5933 2.70331 37.7293 2.70331H39.3559V4.34763H38.2676C38.0762 4.34763 37.9805 4.44156 37.9805 4.62958Z",
    fill: "#A8A8A8"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 5,
    width: 7,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7749 5.16989H45.9937V11.7H39.7749V5.16989Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6047 7.8476H44.1641C44.0204 7.13117 43.5779 6.74357 42.8842 6.74357C42.1907 6.74357 41.7483 7.13117 41.6047 7.8476ZM45.9937 8.90475H41.5809C41.7123 9.70339 42.2147 10.1262 43.0159 10.1262C43.5779 10.1262 43.9846 9.90297 44.152 9.49193H45.9221C45.7068 10.8191 44.5108 11.7 42.9442 11.7C41.0426 11.7 39.7749 10.3962 39.7749 8.43494C39.7749 6.47351 41.0188 5.16989 42.8842 5.16989C44.75 5.16989 45.9937 6.47351 45.9937 8.43494V8.90475Z",
    fill: "#A8A8A8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7056 5.35776V7.35436H49.6772C48.9358 7.35436 48.8042 7.60098 48.8042 8.49371V11.5121H46.8906V5.35776H48.6845V6.48523H48.8042C48.9716 5.80412 49.5456 5.35776 50.2512 5.35776H50.7056Z",
    fill: "#A8A8A8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.343 7.35432V11.5121H55.4295V8.1178C55.4295 7.47185 55.023 7.03721 54.4131 7.03721C53.8031 7.03721 53.3964 7.47185 53.3964 8.1178V11.5121H51.4829V5.35772H53.2768V6.16824H53.3964C53.7313 5.55746 54.4011 5.16986 55.1545 5.16986C56.47 5.16986 57.343 6.03899 57.343 7.35432Z",
    fill: "#A8A8A8"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 5,
    width: 7,
    height: 7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1807 5.16983H64.6027V11.6999H58.1807V5.16983Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6534 8.43488C62.6534 7.53059 62.1511 6.93153 61.3977 6.93153C60.6323 6.93153 60.13 7.53059 60.13 8.43488C60.13 9.33917 60.6323 9.93823 61.3977 9.93823C62.1511 9.93823 62.6534 9.33917 62.6534 8.43488ZM58.1807 8.43488C58.1807 6.47344 59.4723 5.16983 61.3977 5.16983C63.3232 5.16983 64.6029 6.47344 64.6029 8.43488C64.6029 10.3963 63.3232 11.6999 61.3977 11.6999C59.4723 11.6999 58.1807 10.3963 58.1807 8.43488Z",
    fill: "#A8A8A8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2a149a02.svg";
export { ForwardRef as ReactComponent };